var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCard',{staticClass:"hidden-print",attrs:{"title":_vm.$t('other documents'),"custom-id":"certificates"}},[_c('CClassifiedCertificateViewer',{attrs:{"file-data":_vm.certificates}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }